<template>
  <div :class="$style.orderSubmission">

    <h2 :class="$style.submissionMobileTitle">Order Submitted!</h2>

    <div :class="$style.checkmarkImage">
      <svg v-svg
           :class="$style.checkmarkBig"
           symbol="checkmark-icon"/>
    </div>

    <h4 :class="$style.orderSubmissionTitle">
      <span>Order Confirmation</span>
    </h4>

    <div :class="$style.orderInfo">
      <h3 :class="$style.orderInfoTitle">Your Order #{{ checkId }}</h3>
      <span :class="$style.orderInfoType">{{ orderTypeTitle }}</span>

      <div :class="$style.orderInfoItems">

        <OrderField v-for="data in dataFields"
                    :key="data.label"
                    :data="data"/>
      </div>

      <div v-if="isCurbside"
           :class="$style.curbsideMessage">
        <p>
          For curbside pickup, please call our store upon arrival to notify us!
        </p>
      </div>
    </div>

  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import OrderField from '@/components/OrderField';
import { ORDER_TYPES } from '@/config/constants';
import { Getter } from 'vuex-class';

@Component({
  name:       'DesktopConfirmationMain',
  components: {
    OrderField,
  },
  props: {
    dataFields: {},
    checkId:    {
      type:     Number,
      required: true,
    },
  },
})
export default class extends Vue {
  @Getter orderType;

  get isCurbside() {
    return this.orderType === ORDER_TYPES.curbside;
  }

  /**
   * Get string representation for order type
   */
  get orderTypeTitle() {
    if (this.orderType === ORDER_TYPES.inStore) {
      return 'In store';
    }

    if (this.orderType === ORDER_TYPES.curbside) {
      return 'Curbside';
    }

    return '';
  }
}
</script>

<style lang="scss" module>
@import "@/style/variables.scss";
@import "@/style/helpers.scss";

$order-info-border: #DADADA;
$message-color: #4A4A4A;

.orderSubmission {
  min-height: 100%;
  padding: 40px 0 190px;
}

.submissionMobileTitle {
  color: $white;
  font-size: 26px;
  line-height: 28px;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 39px;
  display: none;
}

.checkmarkImage {
  width: 129px;
  height: 129px;
  margin: 0 auto 29px;
  background-color: $green-color;
  border-radius: 50%;

  .checkmarkBig {
    width: 129px;
    height: 129px;
    fill: $checkmark-color;
  }
}

.orderSubmissionTitle {
  overflow: hidden;
  color: $white;
  text-align: center;

  span {
    display: inline-block;
    position: relative;
  }

  span:before,
  span:after {
    content: '';
    position: absolute;
    width: 134px;
    border-top: 3px solid $green-color;
    top: calc(50% - 1.5px);
  }

  span:before {
    left: -164px;
  }

  span:after {
    right: -164px;
  }
}

.orderInfo {
  max-width: 774px;
  margin: 37px auto 0;
  background-color: $white;
  border: 1px solid $order-info-border;
  position: relative;
  padding: 54px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 8px;
    top: 0;
    left: 0;
    background: url("/static/pattern.png") repeat-x;
  }
}

.orderInfoTitle {
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 6px;
}

.orderInfoType {
  display: inline-block;
  background-color: $green-color;
  color: $white;
  padding: 0 5px;
  border-radius: 11px;
  font-family: 'Gotham', sans-serif;
  font-weight: 700;
  font-size: 12px;
  text-transform: uppercase;
  line-height: 23px;
}

.orderInfoItems {
  width: 100%;
  margin-top: 11px;
}

.curbsideMessage {
  width: 100%;
  background-color: $light-choice-bg;
  padding: 16px;

  p {
    text-align: center;
    color: $message-color;
    font-size: 12px;
    font-style: italic;
    line-height: 16px;
  }
}

@media screen and (max-width: $kiosk-breakpoint-max) {
  .orderSubmission {
    padding-top: 120px;
  }
}

@media screen and (max-width: 959px) {
  .orderSubmission {
    padding-bottom: 40px;
  }
}

@media screen and (max-width: 767px) {
  .submissionMobileTitle {
    display: block;
  }
  .orderSubmissionTitle {
    display: none;
  }
  .checkmarkImage {
    width: 120px;
    height: 120px;
    background-color: $checkmark-color;
    border-radius: 50%;

    .checkmarkBig {
      width: 120px;
      height: 120px;
      fill: $green-color;
    }
  }
  .orderInfo {
    background-color: transparent;
    border: 0;
    padding: 0;
    margin-top: 20px;

    &::before {
      content: none;
    }
  }

  .orderInfoTitle {
    color: $white;
    font-size: 22px;
    text-transform: none;
    margin-bottom: 0;
  }

  .orderInfoType {
    background-color: transparent;
    font-weight: 300;
    text-transform: none;
    font-size: 15px;
    padding-bottom: 10px;
    border-radius: 0;
    border-bottom: 4px solid $green-color;
  }

  .orderInfoItems {
    margin-top: 40px;
  }

  .curbsideMessage {
    background-color: transparent;
    margin-top: 30px;

    p {
      color: $white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/desktop/components/DesktopConfirmationMain.vue